import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'td-wb-card-header-title-area',
  template: '<ng-content />',
  styleUrls: ['card-header-title-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-card-header-title-area--center]': 'align() === "center"',
    '[class.td-wb-card-header-title-area--end]': 'align() === "end"'
  }
})
export class CardHeaderTitleAreaComponent {

  align: InputSignal<'start' | 'center' | 'end'> = input<'start' | 'center' | 'end'>('start');

}
